import { useState } from "react";

import MyProfilePage from "./MyProfilePage";
import ChangePassword from "./ChangePassword";
import * as Icon from "react-bootstrap-icons";

export default function BillsUsage() {
  const [subPage, setSubPage] = useState("default");
  return (
    <>
      <div className="individual-wrapper">
        {subPage === "default" && (
          <div className="individual-header">
            <h1>My Profile</h1>
          </div>
        )}
        {subPage === "password" && (
          <span
            className="page-back-link"
            onClick={() => {
              setSubPage("default");
            }}>
            <Icon.ChevronLeft className="page-back-link-icon" />{" "}
            <p className="page-back-link-text">Back</p>
          </span>
        )}
        {subPage === "default" && <MyProfilePage setSubPage={setSubPage} />}
        {subPage === "password" && <ChangePassword />}
      </div>
    </>
  );
}
